module.exports = {
    getDomain: function () {
        return ("https://laescobaencantada.com.mx/api/")
        //return ("http://192.168.20.170:3001/api/")
    },
    getInfoMail:function(){
        return(["info@laescobaencantada.com.mx","!LmMG-45+!"])
    }
}